import { createContext, useContext } from 'react';

export interface WebsocketContextValues {
  type: string;
  payload: any;
}

/**
 * @type {import("react").Context<WebsocketContextValues>}
 * */

const WebsocketContext = createContext<WebsocketContextValues | null>(null);

export const useWebsocket = () => useContext(WebsocketContext);

export { WebsocketContext };
